import { Users } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { CartaoComDestaque } from "@/components/shared/CartaoComDestaque";
import { DA_CLINICA, Resumo } from "./partes-do-cartao";

export function CartaoEquipe() {
  // As mesmas consultas da página Equipe: abrir uma já aquece a outra.
  const membros = trpc.team.list.useQuery();
  const convites = trpc.team.invite.list.useQuery({ status: "PENDING" });

  const n = membros.data?.length ?? 0;
  const pendentes = convites.data?.length ?? 0;
  const resumo = membros.isLoading
    ? "Carregando..."
    : `${n} ${n === 1 ? "membro" : "membros"}${pendentes ? ` · ${pendentes} ${pendentes === 1 ? "convite pendente" : "convites pendentes"}` : ""}`;

  return (
    <CartaoComDestaque
      cor="#0ea5e9"
      icone={Users}
      titulo="Equipe"
      descricao="Quem trabalha na clínica, os convites e o que cada pessoa pode ver e fazer."
      para="/equipe"
      estado={DA_CLINICA}
    >
      <Resumo>{resumo}</Resumo>
    </CartaoComDestaque>
  );
}
